import * as React from 'react';
import * as styles from './client-tags.module.scss';
import TransferList from '../../../common/transfer-list';
import SecondaryButton from '../../../common/secondary-button';
import Tag from '../../../../models/tag';
import Administrator from '../../../../models/administrator';
import { AssignedUser } from '../../../../models/client';

interface Props {
  tag: Tag;
  clientUsers: AssignedUser[];
  clientAdministrators: Administrator[];
  updateUsersHandler: (tag: Tag) => void;
}

const UserModalContent = ({ tag, clientUsers, clientAdministrators, updateUsersHandler }: Props) => {
  const [unassignedUsers, setUnassignedUsers] = React.useState<(AssignedUser | Administrator)[]>([]);
  const [assignedUsers, setAssignedUsers] = React.useState<(AssignedUser | Administrator)[]>([]);
  const [updatedTag, setUpdatedTag] = React.useState<Tag>(tag);

  React.useEffect(() => {
    if (tag.assignedUsers) {
      setAssignedUsers(tag.assignedUsers);
      if (clientUsers || clientAdministrators) {
        setUnassignedUsers([
          ...clientUsers.filter(clientUser => tag.assignedUsers.map(user => user.id).indexOf(clientUser.id) === -1),
          ...clientAdministrators.filter(
            clientAdmin => tag.assignedUsers.map(user => user.id).indexOf(clientAdmin.id) === -1
          )
        ]);
      }
    } else {
      if (clientUsers || clientAdministrators) {
        setUnassignedUsers([...clientUsers, ...clientAdministrators]);
      }
    }
  }, []);

  React.useEffect(() => {
    setUpdatedTag({ ...updatedTag, assignedUsers: assignedUsers });
  }, [assignedUsers]);

  const saveHandler = () => {
    updateUsersHandler(updatedTag);
  };

  return (
    <React.Fragment>
      <form className={styles.userForm}>
        <TransferList
          idField="id"
          labelField="fullName"
          left={unassignedUsers}
          right={assignedUsers}
          setLeft={setUnassignedUsers}
          setRight={setAssignedUsers}
          leftLabel="Unpermissioned Users"
          rightLabel="Permissioned Users"
          setFieldValue={() => {}}
          setField=""
          height="460px"
        />
      </form>
      <div className={styles.modalActionFooter}>
        <SecondaryButton text="Save" title="Save" handleClick={saveHandler} />
      </div>
    </React.Fragment>
  );
};

export default UserModalContent;
